<template>
  <div>
    <com-page>
      <com-package-order-search @search="handleSearch" @onExport="handleExport"></com-package-order-search>
      <com-card>
        <div class="flex items-start mb-5px">
          <h4 class="mt-12px">订单状态</h4>
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane
              :label="item.label"
              :name="item.value"
              v-for="item in statusTag"
              :key="item.value"
            ></el-tab-pane>
          </el-tabs>
        </div>
        <com-package-order-list ref="orderListRef" :defaultParams="defaultParams"></com-package-order-list>
      </com-card>
    </com-page>
  </div>
</template>

<script>
import utils from 'my-tools-library'

export default {
  data() {
    return {
      activeName: '-1',
      statusTag: [
        {
          label: '全部',
          value: '-1'
        },
        {
          label: '已支付',
          value: '1'
        },
        {
          label: '已售后',
          value: '3'
        },
        {
          label: '未支付',
          value: '0'
        }
      ],
      defaultParams: {
        status: ''
      },
      exportQuery: {}
    }
  },
  methods: {
    handleClick() {
      this.defaultParams.status = +this.activeName === -1 ? '' : +this.activeName
      this.$refs.orderListRef.init()

      console.log('activeName', this.activeName)
    },
    handleSearch(val) {
      this.exportQuery = { ...val }

      const params = {
        ...val
      }
      if (val.beginTime) {
        params.startTime = val.beginTime
        delete params.beginTime
      }
      this.$refs.orderListRef.search(params)
    },
    async handleExport() {
      // console.log('handleExport :>> ')
      const params = {
        status: this.defaultParams.status,
        ...this.exportQuery
      }
      const obj = JSON.parse(JSON.stringify(params))
      let i = ''
      let url = ''
      // eslint-disable-next-line prefer-template, guard-for-in, no-restricted-syntax
      for (i in obj) url += '&' + i + '=' + obj[i]
      const downloadUrl = `${process.env.VUE_APP_REQUEST_URL}/chargePieOrder/exportExcel?${url}`
      utils.download(downloadUrl, '订单列表')
    }
  }
}
</script>

<style lang="scss" scoped></style>
